module.exports = __webpack_public_path__ + "webpc/img/icon_share_2.6dd2d205.png";